import { container } from 'tsyringe';

export const Container = container;
